<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row d-flex justify-content-between">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa-brands fa-bots" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="d-flex align-items-center pl-2 pl-sm-0" style="gap:8px;">
            <b-button class="right-align-sm" variant="primary" @click="chatbotPromptAdd">{{cvbtnAddNew}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3" >
          <b-col>
            <b-row class="col-12 col-xl-10">
              <b-col class="col-12 mb-3">
                <b-form-input
                  id="search"
                  v-model="whereFilter.search_param"
                  type="search"
                  :placeholder="cvSearchText"
                  @input="searchFromBackend">
                </b-form-input>
              </b-col>
            </b-row>

            <b-row class="col-12 mb-2">
              <!-- module Filter -->
              <b-col class="mb-2 col-12 col-sm-6">
                <select v-model="whereFilter.prompt_module_name" class="form-control" @change="setModuleName" v-if="modules.length > 0" title="Module List">
                  <option :value="null" disabled>Choose Module</option>
                  <option :value="null">All Modules</option>
                  <option v-for="(module, index) of modules" :key="(index+1)" :value="module.mod_name">
                    {{module.mod_name}}
                  </option>
                </select>
              </b-col>
              <!-- module Filter -->
            </b-row>
          </b-col>
          <!-- Download CSV, Remove Filter button -->
          <!-- <b-col class="mb-2 col-12 col-lg-2 mb-3">
            <i class="fa-solid fa-file-csv Download_button" title="Download CSV" @click="backendCsvDownload"></i>
            <i class="fa-solid fa-filter-circle-xmark Download_button" title="Remove Filters" @click="removeAllFilter"></i>
          </b-col> -->
          <!-- Download CSV, Remove Filter button -->
        </div>
        <div :style="{ minHeight: (!chatbotPromptObjList || chatbotPromptObjList.length === 0) ? '400px' : 'auto'}" class="iq-card row p-3 d-flex align-items-center">
          <b-col md="12" v-if="chatbotPromptObjList && Array.isArray(chatbotPromptObjList) && chatbotPromptObjList.length > 0">
            <b-table
              hover
              responsive
              :items="chatbotPromptObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
            >
              <template v-slot:cell(id)="data">
                <span style="display: block;width: 50px">{{chatbotPromptObjList.indexOf(data.item)+1}}</span>
              </template>
              <template v-slot:cell(prompt_name)="data">
                <span>{{ data.item.prompt_name ? data.item.prompt_name : "-"}}</span><br>
                <b-row class="mt-2">
                  <b-col>
                     <b-button title="Edit prompt" variant="mr-1 mb-1 actionIcon" size="sm" @click="chatbotPromptEdit('MODAL', data.item)"><i class="ri-ball-pen-fill m-0 font-size-20"></i></b-button>
                     <b-button title="View prompt" variant="actionIcon" @click="chatbotPromptView(data.item)" size="sm"><i class="fa fa-eye m-0 font-size-20"></i></b-button>
                  </b-col>
                </b-row>
              </template>
              <template v-slot:cell(prompt)="data">
                {{ data.item.prompt ? data.item.prompt.length > 100 ? (data.item.prompt.substring(0, 100) + '...') : data.item.prompt : "-"}}
              </template>
              <template v-slot:cell(prompt_response)="data">
                {{ data.item.prompt_response ? data.item.prompt_response.length > 100 ? (data.item.prompt_response.substring(0, 100) + '...') : data.item.prompt_response  : "-"}}
              </template>
              <template v-slot:cell(created_on)="data">
                {{ data.item.created_on | dateFormatDDMMYY }}
              </template>
            </b-table>
            <div class="d-flex align-items-center mt-3 py-3">
              <b-col v-if="(currentBatchNo * dataPerPage) < totalDataCount" sm="7" md="8" class="my-1">
                  <b-btn variant="primary" @click="loadMoreData">Load More</b-btn>
              </b-col>
            </div>
          </b-col>
          <b-col v-else-if="chatbotPromptObjList && Array.isArray(chatbotPromptObjList) && chatbotPromptObjList?.length === 0">
            <h5 class="text-secondary text-center">No matching prompts found.</h5>
          </b-col>
          <b-col v-else class="text-center py-5">
            <b-spinner variant="primary" class="align-middle"></b-spinner>
            <h5 class="mt-3 text-primary">Loading prompts...</h5>
            <p class="text-muted mb-0">Please wait while prompt records are being loaded.</p>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelchatbotPromptAdd"
      scrollable
      :title="cvAddModalHeader"
      size="xxl"
    >
      <chatbotPromptAdd :propOpenedInModal="true" :propModules="modules" @emitClosechatbotPromptAddModal="closechatbotPromptAddModal"/>
      <template #modal-footer="">
        <b-button size="sm" @click="closechatbotPromptAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelchatbotPromptEdit"
      scrollable
      :title="cvEditModalHeader"
      size="xxl"
    >
      <chatbotPromptEdit :propOpenedInModal="true" :propChatbotPromptObj="chatbotPromptEditObj" :propModules="modules" @emitClosechatbotPromptEditModal="closechatbotPromptEditModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closechatbotPromptEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelchatbotPromptView"
      scrollable
      :title="cvViewModalHeader"
      size="xxl"
    >
      <chatbotPromptView :propChatbotPromptObj="chatbotPromptViewObj" @emitClosechatbotPromptViewModal="closechatbotPromptViewModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closechatbotPromptViewModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelChatbotPromptDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelChatbotPromptDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="chatbotPromptDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import chatbotPromptAdd from "./ChatbotPromptAdd.vue"
import chatbotPromptEdit from "./ChatbotPromptEdit.vue"
import chatbotPromptView from "./ChatbotPromptView.vue"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import Utility from "../../../Utils/utility.js"
import { ChatbotPromptApiObj } from "../../../FackApi/api/chatbotPrompt.js"
import { moduleApiObj } from "../../../FackApi/api/module.js"

export default {
  name: "chatbotPromptList",
  components: {
    chatbotPromptAdd,
    chatbotPromptEdit,
    chatbotPromptView
  },
  data () {
    return {
      cvCardTitle: "Chatbot Prompts",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit Chatbot Prompt",
      cvAddModalHeader: "Add Chatbot Prompt",
      cvViewModalHeader: "View Chatbot Prompt",
      cvbtnModalCancel: "Cancel",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Chatbot Prompt",
      showModelchatbotPromptAdd: false,
      showModelchatbotPromptEdit: false,
      showModelChatbotPromptDelete: false,
      showModelchatbotPromptView: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "#", key: "Id", class: "text-left align-text-top", sortable: true },
        { label: "Prompt Name", key: "prompt_name", class: "text-left align-text-top w-300px", sortable: true },
        { label: "Prompt Service", key: "prompt_service", class: "text-left align-text-top w-200px", sortable: true },
        { label: "Prompt Module Name", key: "prompt_module_name", class: "text-left align-text-top w-300px", sortable: true },
        { label: "Prompt Module Id", key: "prompt_module_id", class: "text-left align-text-top w-350px", sortable: true },
        { label: "Prompt", key: "prompt", class: "text-left align-text-top w-350px", sortable: true },
        { label: "Prompt Macro", key: "prompt_macro", class: "text-left align-text-top w-350px", sortable: true },
        { label: "Prompt Response", key: "prompt_response", class: "text-left align-text-top w-350px", sortable: true },
        { label: "Created On", key: "created_on", class: "text-left align-text-top w-200px", sortable: true }
      ],
      chatbotPromptObjList: null,
      chatbotPromptEditObj: null,
      chatbotPromptViewObj: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      delObj: null,
      search_param: "",
      domain_filter: "",
      module_name: "",
      currentBatchNo: 1,
      dataPerPage: 25,
      showLoadMoreBtn: true,
      whereFilter: {
        search_param: "",
        prompt_module_name: null
      },
      doCopy: Utility.doCopy,
      totalDataCount: 0,
      modules: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async mounted () {
    socialvue.index()
    this.chatbotPromptList()
    this.moduleList()
  },
  methods: {
    /**
     * searchFromBackend
     */
    searchFromBackend () {
      if (this.whereFilter.search_param.length <= 2 && this.whereFilter.search_param.length != 0) {
        return
      }
      this.currentBatchNo = 1
      this.chatbotPromptList()
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.chatbotPromptList(true)
    },
    /**
     * set Filters
     */
    async setFilters () {
      this.currentBatchNo = 1
      this.chatbotPromptList()
    },
    /**
     * chatbotPromptList
     */
    async chatbotPromptList (loadViaLoadMore = false, downloadCsv = false) {
      try {
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.search_param = this.whereFilter.search_param
        if (this.whereFilter.downloadCsv) {
          this.whereFilter.downloadCsv = downloadCsv
        }

        let chatbotPromptListResp = await ChatbotPromptApiObj.chatbotPromptList(this, this.whereFilter)
        if (chatbotPromptListResp.resp_status) {
          if (downloadCsv) {
            window.open(chatbotPromptListResp.resp_csv_file_url)
            return
          }

          console.log("loadViaLoadMore", loadViaLoadMore)
          if (!loadViaLoadMore) {
            this.chatbotPromptObjList = [ ...chatbotPromptListResp.resp_data.data ]
          }
          else {
            this.chatbotPromptObjList = [ ...this.chatbotPromptObjList, ...chatbotPromptListResp.resp_data.data ]
          }

          this.totalDataCount = chatbotPromptListResp.resp_data_total_count
        }
        else {
          this.toastMsg = chatbotPromptListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          this.chatbotPromptObjList = []
        }
      }
      catch (err) {
        this.toastMsg = "Failed to fetch prompts. Please try again."
        this.toastVariant = "danger"
        this.showToast = true
        this.chatbotPromptObjList = []
        console.error("Exception occurred at chatbotPromptList() and Exception:", err.message)
      }
    },
    /**
     * chatbotPromptView
     */
    chatbotPromptView (promptObj) {
      this.chatbotPromptViewObj = promptObj
      this.showModelchatbotPromptView = true
    },
    /**
     * chatbotPromptAdd
     */
    chatbotPromptAdd (type = "MODAL") {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/chatbot_prompt_add")
        }
        else {
          this.showModelchatbotPromptAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at chatbotPromptAdd() and Exception:", err.message)
      }
    },
    /**
     * chatbotPromptEdit
     */
    chatbotPromptEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/chatbot_prompt_edit/" + this.chatbotPromptEditObj.prompt_id)
        }
        else {
          this.chatbotPromptEditObj = {
            prompt_name: item.prompt_name,
            prompt_service: item.prompt_service,
            prompt_module_name: item.prompt_module_name,
            prompt: item.prompt,
            prompt_macro: item.prompt_macro,
            prompt_id: item.prompt_id
          }
          this.showModelchatbotPromptEdit = true
        }
      }
      catch (err) {
        console.error("Exception occurred at chatbotPromptEdit() and Exception:", err.message)
      }
    },
    /**
     * chatbotPromptDelete
     */
    async chatbotPromptDelete () {
      try {
        let chatbotPromptDelResp = await ChatbotPromptApiObj.chatbotPromptDelete(this, this.delObj.prompt_id)
        await ApiResponse.responseMessageDisplay(this, chatbotPromptDelResp)

        if (chatbotPromptDelResp && !chatbotPromptDelResp.resp_status) {
          this.showModelChatbotPromptDelete = false
          return false
        }

        let index = this.chatbotPromptObjList.indexOf(this.delObj)
        this.chatbotPromptObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelChatbotPromptDelete = false
      }
      catch (err) {
        console.error("Exception occurred at chatbotPromptDelete() and Exception:", err.message)
      }
    },
    /**
     * closechatbotPromptAddModal
     */
    closechatbotPromptAddModal () {
      try {
        this.chatbotPromptList()
        this.showModelchatbotPromptAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closechatbotPromptAddModal() and Exception:", err.message)
      }
    },
    /**
     * closechatbotPromptEditModal
     */
    closechatbotPromptEditModal () {
      try {
        this.chatbotPromptList()
        this.showModelchatbotPromptEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closechatbotPromptEditModal() and Exception:", err.message)
      }
    },
    /**
     * closechatbotPromptViewModal
     */
    closechatbotPromptViewModal () {
      try {
        this.showModelchatbotPromptView = false
      }
      catch (err) {
        console.error("Exception occurred at closechatbotPromptViewModal() and Exception:", err.message)
      }
    },
    /**
     * moduleList
     */
    async moduleList (payload) {
      try {
        let moduleListResp = await moduleApiObj.moduleList(this)
        if (moduleListResp.resp_status) {
          this.modules = moduleListResp.resp_data.data
        }
      }
      catch (err) {
        console.error("Exception occurred at moduleList() and Exception:", err.message)
      }
    },
    /**
     * setModuleName
     */
    setModuleName () {
      this.currentBatchNo = 1
      this.chatbotPromptList()
    }
  }
}
</script>
